import { ReactElement } from 'react';
import { Spinner } from '@weareopenr/component-library';
import { useMenuSet } from 'src/hooks/useMenuSet';
import { SpinnerContainer } from 'src/components/SpinnerContainer';
import { MenuSetDetailsForm } from './MenuSetDetailsForm';

export interface MenuSetDetailsTrayContentProps {
  menuSetId: string;
  onClose: () => void;
  onDirtyChange?: (isDirty: boolean) => void;
  openId: number;
}

export const MenuSetDetailsTrayContent = ({
  menuSetId,
  onClose,
  onDirtyChange,
  openId,
}: MenuSetDetailsTrayContentProps): ReactElement => {
  const { data, isLoading } = useMenuSet(menuSetId);
  const menuSet = data?.data[0];

  if (isLoading || !menuSet) {
    return (
      <SpinnerContainer>
        <Spinner size="large" colour="rainbow" />
      </SpinnerContainer>
    );
  }

  // Keyed by openId so every open starts from the saved menu set; closing without saving drops the edits.
  return <MenuSetDetailsForm key={openId} menuSet={menuSet} onClose={onClose} onDirtyChange={onDirtyChange} />;
};

export default MenuSetDetailsTrayContent;
